import { useGetFilters } from '@services/filters';
import { useEffect } from 'react';
import { useFilterKey } from './useFilterKey';
import { useAppContext } from '@contexts/app';
import { useQueryParams } from './queryParams';

export const useFilters = () => {
  const { setData, filters } = useAppContext();
  const filterKey = useFilterKey();
  const { params, setParams } = useQueryParams();
  const { data } = useGetFilters();
  const newFilters = data?.data;

  useEffect(() => {
    setParams({ ...params, ...filters?.[filterKey] }, { disableSaveFilters: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, filterKey]);

  useEffect(() => {
    if (!newFilters || !setData) return;
    setData((prev) => ({ ...prev, filters: newFilters }));
  }, [newFilters, setData]);
};
